// 2026-10-14：六类商品封面统一9:16居中裁剪与可配置清晰度，仅处理可信公共OSS地址，保留原图和受保护链接。
export type ProductCoverResolution='preserve'|'480p'|'360p'

export interface ProductCoverConfig {
  ratioWidth:number;
  ratioHeight:number;
  resolution:ProductCoverResolution;
}

export const PRODUCT_COVER_CONFIG:Readonly<ProductCoverConfig>={ratioWidth:9,ratioHeight:16,resolution:'480p'}
// 2026-10-15：面料、辅料、饰品独立采用1:1封面，沿用默认480P；版型与成衣继续使用9:16。
export const SQUARE_PRODUCT_COVER_CONFIG:Readonly<ProductCoverConfig>={...PRODUCT_COVER_CONFIG,ratioWidth:1,ratioHeight:1}
export const PRODUCT_COVER_WIDTHS={'480p':480,'360p':360} as const

export function productCoverStyle(config:Readonly<ProductCoverConfig>=PRODUCT_COVER_CONFIG):Record<string,string>{
  return {'--product-cover-ratio':`${config.ratioWidth} / ${config.ratioHeight}`}
}

function queryPart(value:string):string {
  return decodeURIComponent(value.replace(/\+/g,' '))
}

export function productCoverUrl(value:string|undefined,preserveHeight:300|400,
  config:Readonly<ProductCoverConfig>=PRODUCT_COVER_CONFIG):string {
  const source=value || ''
  if(!source || source.trim()!==source)return source
  try {
    const url=new URL(source)
    if(!['http:','https:'].includes(url.protocol) || url.hostname!=='allfiles.landiyun.com'
      || url.username || url.password || url.port)return source
    const hashIndex=source.indexOf('#'),hash=hashIndex<0?'':source.slice(hashIndex)
    const address=hashIndex<0?source:source.slice(0,hashIndex),queryIndex=address.indexOf('?')
    const base=queryIndex<0?address:address.slice(0,queryIndex)
    const query=queryIndex<0?'':address.slice(queryIndex+1),parts=query?query.split('&'):[]
    const processIndexes:number[]=[]
    for(let index=0;index<parts.length;index++){
      const key=queryPart(parts[index].split('=',1)[0]).toLowerCase()
      // 2026-10-14：签名、有效期和临时凭据查询参数不重新编码或追加处理，避免使受保护图片失效。
      if(/signature|credential|token|expires|access.?key|authorization|auth_?key/.test(key))return source
      if(key==='x-oss-process')processIndexes.push(index)
    }
    if(processIndexes.length>1)return source
    // 2026-10-14：清晰度宽度固定，输出高度随封面比例推导，默认480×854或360×640。
    if(!Number.isFinite(config.ratioWidth) || !Number.isFinite(config.ratioHeight)
      || config.ratioWidth<=0 || config.ratioHeight<=0)return source
    const width=config.resolution==='preserve'?null:PRODUCT_COVER_WIDTHS[config.resolution]
    const dimensions=width?{width,height:Math.ceil(width*config.ratioHeight/config.ratioWidth)}:null
    const resize=dimensions?`resize,m_fill,w_${dimensions.width},h_${dimensions.height},limit_1`
      :`resize,h_${preserveHeight},m_lfit`
    let process=`image/${resize}`
    if(processIndexes.length){
      const part=parts[processIndexes[0]],separator=part.indexOf('=')
      const previous=separator<0?'':queryPart(part.slice(separator+1))
      const operations=previous.split('/')
      // 2026-10-14：只替换已识别的resize操作，保留format/watermark等；样式名和歧义处理链保持原地址。
      if(operations[0]!=='image' || operations.length<2 || operations.some(operation=>!operation))return source
      const resizeIndexes=operations.map((operation,index)=>/^resize(?:,|$)/.test(operation)?index:-1).filter(index=>index>=0)
      if(resizeIndexes.length>1)return source
      if(resizeIndexes.length)operations[resizeIndexes[0]]=resize
      else operations.splice(1,0,resize)
      process=operations.join('/')
    }
    const encoded=encodeURIComponent(process).replace(/%2F/g,'/').replace(/%2C/g,',')
    const parameter=`x-oss-process=${encoded}`
    if(processIndexes.length)parts[processIndexes[0]]=parameter
    else parts.push(parameter)
    return `${base}?${parts.join('&')}${hash}`
  }catch {
    return source
  }
}
